import React, { useEffect, useState } from "react";
import "./Layout.scss";
import { Button, Result, Spin, Layout } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setNetworkDrop } from "store/slice/login-slice";
import Loader from "Components/Loader";
import {
  NiyamaLogoText,
  NiyamaTestLogoText,
  NiyamaNewLogo,
  NiyamaStgLogoText,
} from "Common/ReactIcons";
import { ReactComponent as ErrorIconOf } from "assets/icons/ErrorIconOf.svg";
import { ReactComponent as NoNetworkIcon } from "assets/icons/NoNetworkIcon.svg";
import { NETWORK_BACK_MSG, SOMETHING_WRONG_MSG, OFFLINE_MSG, CHECK_NETWORK_MSG, ORG_ID, CHECK_NETWORK_MSG_OFFLINE, SOMETHING_WRONG_MSG_1 } from "Common/constant";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const dispatch = useDispatch();
  const user_details = useSelector((state) => state.loginReducer.user_details);
  const networkError = useSelector((state) => state.loginReducer.networkError);
  const { Header } = Layout;
  const [Logo, isSetLogo] = useState("");
  const [colorTheme, isSetColorTheme] = useState(true);
  const [isOffline, setIsOffline] = useState(!navigator.onLine || !!networkError);
  const handleRetry = () => {
    window.location.reload();
  };

  const handleOffline = () => {
    setIsOffline(true);
    dispatch(setNetworkDrop(true));
  };

  // Browser comes online
  const handleOnline = () => {
    setIsOffline(false);
    dispatch(setNetworkDrop(false));
  };
  const partnerLogo = () =>{
    const org_id = user_details?.org_name || (user_details?.role === "Guest" && window.location.host) || "default";
    const logo = ORG_ID[org_id] ? ORG_ID[org_id]  :  ORG_ID["default"];
    isSetLogo(logo.full_logo)
    isSetColorTheme(false)
  }
  const isChunkError = !!(error && error.toString().toLowerCase().includes("chunk"));

  useEffect(() => {
    if (isChunkError && navigator.onLine) {
      window.location.reload();
      return;
    }
    if(colorTheme || (Logo != (user_details?.org_name || (user_details?.role === "Guest" && window.location.host) || "default"))){
      partnerLogo()
    }
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  const showChunkSpinner = isChunkError && navigator.onLine;
  return (
    <>
      {showChunkSpinner ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin tip="Loading" size="large" />
        </div>
      ) : (
        <>
      <Header className="header-layout" id="header">
        <div className="logo-container error-logo-container">
          {/*process.env.REACT_APP_ENV == "dev" ? (
            <img src={Logo} />
            // <NiyamaNewLogo className="main-logo" />
          ) : process.env.REACT_APP_ENV == "test" ? (
            <NiyamaTestLogoText className="main-logo" />
          ) : process.env.REACT_APP_ENV == "staging" ? (
            <NiyamaStgLogoText className="main-logo" />
          ) : (
            <NiyamaLogoText className="main-logo" />
          )}*/}
          <img src={Logo} style={{width:"125px", marginLeft:"0px"}}/>
        </div>
      </Header>

        <Result
          icon={
            isOffline ? (
              <NoNetworkIcon style={{ width: "320px", height: "320px"}} />
            ) : (
              <ErrorIconOf style={{ width: "320px", height: "320px"}} />
            )
          }
          // title={
          //   <div>
          //     <span className="chk-netwk_title">
          //       {navigator.onLine ? SOMETHING_WRONG_MSG : OFFLINE_MSG}
          //     </span>
          //   </div>
          // }
          subTitle={
            <div>
                {isOffline ? (
                  <span className="chk-netwk_msg">{CHECK_NETWORK_MSG_OFFLINE}</span>
              ) : (
                <span className="chk-netwk_msg">{SOMETHING_WRONG_MSG_1}</span>
              )}
            </div>
          }
          extra={
            <div className="error-boundary-container">
                <Button
                  className="error-boundary-button"
                  onClick={handleRetry}
                >
                  Try again
                </Button>
            </div>
            }
            />
          </>
        )}
      </>
    );
  };
  
export default ErrorFallback;
